export default "__VITE_ASSET__DWvh0PCC__"